import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-terms-of-use-modal",
  imports: [],
  templateUrl: "./terms-of-use-modal.component.html",
  styleUrls: ["./terms-of-use-modal.component.scss"],
})
export class TermsOfUseModalComponent {
  constructor(private readonly matDialog: MatDialog) {}

  protected close() {
    this.matDialog.closeAll();
  }
}
